/**
 * What the location dialog places in the chosen lesson: a quiz from the question generator, or a
 * Tutor AI document as an HTML (Mint) page.
 */
export const LOCATION_DIALOG_TARGETS = {
  QUIZ: 'quiz',
  MINT: 'mint',
} as const;

export type LocationDialogTarget = (typeof LOCATION_DIALOG_TARGETS)[keyof typeof LOCATION_DIALOG_TARGETS];
